import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { isNotEmpty } from 'utils/functional';

import { getCmsBlockHasBackground } from './getCmsBlockHasBackground';
import { getIsContentFullWidthLayout } from './getIsContentFullWidthLayout';

type Args = {
  content: CmsApiPage;
};

export function getCmsContentPadTop({ content }: Args) {
  const firstBlock = content.contentBlocks[0];
  if (!firstBlock) return false;

  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    isNotEmpty(content.contentBlocks) &&
    !(
      [
        'STICKY_HEADER_LINKS',
        'CTA_HERO',
        'DONATE',
        'SIGN_UP',
        'SCROLL_TRACKING',
      ].includes(firstBlock.type) ||
      (firstBlock.type === 'SPLIT_CONTENT' &&
        ['FULL_WIDTH', 'OVERLAPPING'].includes(firstBlock.data.appearance)) ||
      getCmsBlockHasBackground({ block: firstBlock, fullWidthLayout })
    )
  );
}
